// Storage is an invalidation signal only; the cookie-authenticated API supplies identity.
let epoch = 0;
let controller = new AbortController();
const listeners = new Set();
const invalidate = () => {
  epoch += 1;
  controller.abort();
  controller = new AbortController();
  listeners.forEach(listener => listener());
};
const onStorage = event => {
  if (event.storageArea === window.localStorage && (event.key === null || ['user_token', 'user_data'].includes(event.key))) invalidate();
};

export const subscribeSession = listener => {
  if (!listeners.size) {
    window.addEventListener('storage', onStorage);
    window.addEventListener('loginStateChanged', invalidate);
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (!listeners.size) {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('loginStateChanged', invalidate);
    }
  };
};
export const sessionEpoch = () => epoch;
export const currentSession = () => ({ epoch, signal: controller.signal });
export const assertCurrentSession = session => {
  if (session.epoch !== epoch || session.signal.aborted) {
    const error = new Error('Your account session changed. Reload the current workspace before acting.');
    error.status = 401;
    throw error;
  }
};